import Blacklist from '@/app/util/lang-filter/blacklist'
import { shuffle } from '@/common/util/string-utils'

declare interface ILangFilter {
    clean (data: string): boolean
    filter (data: string): string
}

/**
 * Language filter
 *
 * Based on: https://github.com/snipe/banbuilder
 */
class LangFilter implements ILangFilter {
    /* eslint-disable no-useless-escape */
    blacklist: Array<string> = Blacklist
    replaceCharacters = '#*%@^$'
    leetBlacklist: Array<RegExp> = []
    leetReplace: Record<string, string> = {
        a: '(a|a\.|a\-|4|@|Á|á|À|Â|à|Â|â|Ä|ä|Ã|ã|Å|å|α|Δ|Λ|λ)',
        b: '(b|b\.|b\-|8|3|ß|Β|β)',
        c: '(c|c\.|c\-|Ç|ç|¢|€|<|{|©)',
        d: '(d|d\.|d\-|Þ|þ|Ð|ð)',
        e: '(e|e\.|e\-|3|€|È|è|É|é|Ê|ê|∑)',
        f: '(f|f\.|f\-|ƒ)',
        g: '(g|g\.|g\-|6|9)',
        h: '(h|h\.|h\-|Η)',
        i: '(i|i\.|i\-|!|1|∫|Ì|Í|Î|Ï|ì|í|î|ï)',
        j: '(j|j\.|j\-)',
        k: '(k|k\.|k\-|Κ|κ)',
        l: '(l|1\.|l\-|!|\||\]|\[|]|£|∫|Ì|Í|Î|Ï)',
        m: '(m|m\.|m\-)',
        n: '(n|n\.|n\-|η|Ν|Π)',
        o: '(o|o\.|o\-|0|Ο|ο|Φ|¤|°|ø)',
        p: '(p|p\.|p\-|ρ|Ρ|¶|þ)',
        q: '(q|q\.|q\-)',
        r: '(r|r\.|r\-|®)',
        s: '(s|s\.|s\-|5|\\$|§)',
        t: '(t|t\.|t\-|Τ|τ|7)',
        u: '(u|u\.|u\-|υ|µ)',
        v: '(v|v\.|v\-|υ|ν)',
        w: '(w|w\.|w\-|ω|ψ|Ψ)',
        x: '(x|x\.|x\-|Χ|χ)',
        y: '(y|y\.|y\-|¥|γ|ÿ|ý|Ÿ|Ý)',
        z: '(z|z\.|z\-|Ζ)'
    }

    constructor () {
        this.generateLeetBlacklist()
    }

    private generateLeetBlacklist (): void {
        const tmp: Array<string> = []

        for (let i = 0; i < this.blacklist.length; i++) {
            tmp[i] = this.blacklist[i]

            for (const key in this.leetReplace) {
                if (Object.prototype.hasOwnProperty.call(this.leetReplace, key)) {
                    tmp[i] = tmp[i].replace(key, this.leetReplace[key])
                }
            }

            this.leetBlacklist[i] = new RegExp(tmp[i], 'i')
        }
    }

    clean (data: string): boolean {
        for (const regex of this.leetBlacklist) {
            if (data.search(regex) !== -1) {
                return false
            }
        }

        return true
    }

    filter (data: string): string {
        let result = data

        for (const regex of this.leetBlacklist) {
            if (result.search(regex) !== -1) {
                result = result.replace(regex, shuffle(this.replaceCharacters))
            }
        }

        return result
    }
}

export default new LangFilter() as ILangFilter

export {
    ILangFilter,
    LangFilter
}
